import{createContext as o}from"react";import{Constants as r}from"../../constants/index.js";const t=o({isDarkMode:!0,theme:r.Color,toggleDarkMode:void 0});export{t as StylesContext};
